import { css } from 'styled-components'

import { inputBase } from './input-base'

export const inputStyles = css`
  ${inputBase};
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  border-radius: 4px;
  outline: none;
  padding: ${({ theme }) => theme.spacing(1.5)};
  ${({ theme }) => theme.typography.heading2};

  &::placeholder {
    color: ${({ theme }) => theme.palette.disabled.main};
  }

  &:active,
  &:focus,
  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.border.main};
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
`
